import { memo, useCallback, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { Button } from '@cbhq/cds-web/buttons';
import { HeroSquare } from '@cbhq/cds-web/illustrations/HeroSquare';
import { VStack } from '@cbhq/cds-web/layout';
import { TextBody, TextTitle3 } from '@cbhq/cds-web/typography';

import { AnalyticEvent } from ':fat/analytics/events';
import { logRender } from ':fat/analytics/logActions';
import { SingleColumnLayout } from ':fat/components/PageLayout/SingleColumnLayout';

import { messages } from './messages';

export const ErrorFallbackPage = memo(function ErrorFallbackPage() {
  const { formatMessage } = useIntl();

  const handleTryAgainPress = useCallback(() => {
    window.location.reload();
  }, []);

  useEffect(() => {
    logRender(AnalyticEvent.ErrorFallbackPageRendered);
  }, []);

  return (
    <SingleColumnLayout>
      <VStack alignItems="center" justifyContent="center" spacing={4} maxWidth={450}>
        <HeroSquare name="errorWeb500" dimension="240x240" />
        <VStack spacingVertical={4} alignItems="center">
          <TextTitle3 as="p">{formatMessage(messages.title)}</TextTitle3>
          <TextBody as="p" align="center" color="foregroundMuted" spacingTop={1}>
            {formatMessage(messages.description)}
          </TextBody>
        </VStack>

        <Button block onPress={handleTryAgainPress}>
          {formatMessage(messages.tryAgain)}
        </Button>
      </VStack>
    </SingleColumnLayout>
  );
});
